<template>
<!-- v-html="html" -->
  <article
    class="vm-article-box"
    ref="article"
    :class="{overflow: !is_open && is_overflow && !is_show_all, 'article-box': is_open || is_show_all || !is_overflow, 'plan-style': is_plan_style}"
    @click="open"
    v-html="html">
  </article>
</template>

<script>
// import Vue from 'vue'
// let htmlContent = Vue.component('html-content',{
//   template: '1111'
// })
// console.log(Vue)
// import hljs from 'highlight.js';

import hljs from 'highlight.js/lib/core';
import javascript from 'highlight.js/lib/languages/javascript';
hljs.registerLanguage('javascript', javascript);
import 'highlight.js/styles/base16/edge-light.css';
// import hljs from 'highlight.js/lib/core';
// import javascript from 'highlight.js/lib/languages/javascript';
// import vuePlugin from "highlightjs/vue-plugin";
// hljs.registerLanguage('javascript', javascript);

// Vue.use(vuePlugin);
export default {
  name: 'article-box',
  props: {
    text: {
      type: String,
      default: '',
    },
    url: {
      default: '',
    },
    n: {
      type: Number,
      default: 80,
    },
    is_show_all: {
      type: Boolean,
      default: false,
    },
    is_href_blank: {
      type: Boolean,
      default: false,
    },
    is_n2br: {
      type: Boolean,
      default: false,
    },
    is_html2br: { //是否 p、div等换成换行
      type: Boolean,
      default: false,
    },
    is_plan_style: {
      type: Boolean,
      default: false,
    },
    limit_img_count:{
      type: Number,
      default: 0,
    },
    limit_wrap_count:{
      type: Number,
      default: 3,
    },
    is_open_big_img:{
      default: false,
    },
    open_text:{
      default: '查看全文', //新建打开  open，   当前打开，self
    },
  },
  data() {
    let pre_text = this.$remove_html_tag(this.text);
    if(this.is_html2br){
        let br_text = this.text.replace(/<\/p>/g,'[--br--]').replace(/<\/div>/g,'[--br--]')
        pre_text = this.$remove_html_tag(br_text).replace(/\[--br--\]/g,'<br>').replace(/\n/g,'<br>'); //先标记，再换回换行
    }

    let arr = this.text.match(/<img/g);
    let img_count = arr ? arr.length : 0;
    let arr1 = pre_text.match(/\n/g);
    let arr2 = this.text.match(/<\/p>/g);
    let arr3 = this.text.match(/<\/div>/g);
    let wrap_count = arr1 ? arr1.length : arr2 ? arr2.length : arr3 ? arr3.length : 0;
    let is_overflow = pre_text.length > this.n || img_count > this.limit_img_count || wrap_count > this.limit_wrap_count;
    if (is_overflow) {
      pre_text = pre_text.substring(0, this.n);
      // if(img_count){
      //   pre_text = pre_text.replace(/<br>/g,'')
      // }
    }
    return {
      pre_text,
      is_overflow,
      is_open: false,
      is__n2br:this.is_n2br,
      is__html2br:this.is_html2br,
      img_count,
    };
  },
  computed: {
    html() {
      if (!this.is_show_all && !this.is_open && this.is_overflow) {
        return `${this.pre_text}...<span class="black-5 gl-hover-text">${this.open_text}</span>`;
      }
      let _text = this.text;

      if (this.is_show_all || this.is_open || !this.is_overflow) {
        if(this.is_open_big_img){
          _text = this.text.replace(/<img\s/g,'<img afd-big-image="1" ')
        }
        if(this.is__n2br){
           return _text.replace(/\n/g,'<br>').replace(/\r/g,'<br>')
        }
        if(this.is__html2br){
        //    return this.text.replace(/\p/g,'<br>').replace(/\r/g,'<br>')
        }

        return _text;
      }
    },
  },
  watch:{
    //   is_show_all(v1,v2){
    //       console.log(v1)
    //       if(v1){
    //         document.querySelectorAll('pre').forEach(el => {
    //           // then highlight each
    //           hljs.highlightElement(el);
    //         });
    //       }
    //   }
  },
  // components:{
  //   htmlContent: Vue.extend({
  //     template: '<a @click="show(1)">我是大魔王</a>',
  //       methods: {
  //         show(i) {
  //             console.log(i);
  //         },
  //     }
  //   })
  // },
  created(){
    // console.log(this.html)

  },
  mounted() {
    // console.log(this.is_show_all)
    //   console.log(this.$el.querySelectorAll('pre'))


    this.$el.querySelectorAll('pre').forEach(el => {
              // then highlight each
        hljs.highlightElement(el);
    });



//     const MyComponent = Vue.extend({
//     template: '<a @click="show(1)">我是大魔王</a>',
//       methods: {
//         show(i) {
//             console.log(i);
//         },
//     }
// });
// var component = new MyComponent().$mount();
//     console.log(this.$refs.article)
    // this.$refs.article.appendChild(component.$el);
    // document.getElementById('parent').appendChild(component.$el);
    // Vue.component('html-content')
  },
  update(){
  },
  methods: {
    open(e) {
      let a_target = '';
      let t = e.target;
      for(var i = 0;i < 4; i++){ //检查4层
        if(t.nodeName == 'A'){
            a_target = t;
            break;
        }
        if(t.nodeName != 'A' && t.parentNode && (t.parentNode.getAttribute('class') && t.parentNode.getAttribute('class').indexOf('vm-article-box') == -1 || !t.parentNode.getAttribute('class'))){
            t = t.parentNode;
        }
      }
      if (a_target) {
        let href = a_target.getAttribute('href');
        if (
          href &&
          href.indexOf('http') != -1 &&
          href.indexOf('afdian.net') == -1
        ) {
          e.preventDefault();
          this.$mixin_router_push(`/link?target=${href}`);
          return false;
        }
        if(this.GL.ENV.is_afd_client){
            e.preventDefault();
            this.$mixin_router_push('', this.is_href_blank, href)
            return false;
        }
      }
      if (this.url && !this.is_show_all && e.target.nodeName != 'IMG') {
        this.$mixin_router_push(this.url, this.is_href_blank)
        // if (this.is_href_blank) {
        //   window.open(this.url);
        //   return false;
        // }
        // this.$router.push(this.url);
        return false;
      }
      if (this.is_overflow) {
        this.is_open = true;
        this.pre_text = this.text;
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.vm-article-box {
  &.overflow {
    cursor: pointer;
    font-size: 12px;
    line-height: 1.7;
  }
  &.plan-style{
    font-size: 16px;
    color: rgba(0,0,0,.8);
    line-height: 1.7;
  }
}
</style>
